import { useCallback, useEffect, useState } from 'react';

import { CASHBACK_MODAL_OPEN_DELAY_MS } from '../constants';

type UseCashbackGrowthDelayedModalParams = {
  active: boolean;
  delayMs?: number;
};

export const useCashbackGrowthDelayedModal = (params: UseCashbackGrowthDelayedModalParams) => {
  const { active, delayMs = CASHBACK_MODAL_OPEN_DELAY_MS } = params;
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!active) {
      setModalOpen(false);
      return;
    }

    const timeoutId = window.setTimeout(() => setModalOpen(true), delayMs);
    return () => window.clearTimeout(timeoutId);
  }, [active, delayMs]);

  const closeModal = useCallback(() => setModalOpen(false), []);

  return { modalOpen, closeModal };
};
